export default __webpack_public_path__ + "static/media/SoftCut-Active-01.d00877c5.jpg";